import { render, staticRenderFns } from "./BindAccList.vue?vue&type=template&id=23d1b23a&scoped=true&"
import script from "./BindAccList.vue?vue&type=script&lang=js&"
export * from "./BindAccList.vue?vue&type=script&lang=js&"
import style0 from "./BindAccList.vue?vue&type=style&index=0&id=23d1b23a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d1b23a",
  null
  
)

export default component.exports